import { useEffect, useState } from 'react'

import { APP_RECAPTCHA_SITEKEY } from '../../services'

const SITE_KEY = `${APP_RECAPTCHA_SITEKEY()}`

declare global {
  interface Window {
    captchaOnLoad: () => void
    grecaptcha: ReCaptchaInstance
  }
}

interface ReCaptchaInstance {
  ready: (cb: () => any) => any
  execute: () => Promise<string>
  render: (id: string, options: ReCaptchaRenderOptions) => any
}

interface ReCaptchaRenderOptions {
  sitekey: string
  size: 'invisible'
}

interface Props {
  children: (props: CaptchaProps) => JSX.Element
}

interface CaptchaProps {
  isReady: boolean
  execute: () => Promise<string>
}

export function ReCaptcha(props: Props) {
  const [isReady, setIsReady] = useState<boolean>(false)

  useEffect(() => {
    loadScript()
    return () => {
      let d = document.getElementById('g-recaptcha')
      if (d?.parentNode) {
        d?.parentNode.removeChild(d)
      }
      d = document.getElementById('g-recaptcha-script')
      if (d?.parentNode) {
        d?.parentNode.removeChild(d)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onLoad = (): void => {
    let widget = document.createElement('div')
    widget.id = 'g-recaptcha'
    widget = document.body.appendChild(widget)

    window.grecaptcha.render('g-recaptcha', {
      sitekey: SITE_KEY,
      size: 'invisible'
    })

    setIsReady(true)
  }

  const loadScript = (): void => {
    window.captchaOnLoad = onLoad
    const url = 'https://www.google.com/recaptcha/api.js'
    const queryString = '?onload=captchaOnLoad&render=explicit'
    let script = document.createElement('script')
    script.id = 'g-recaptcha-script'
    script.type = 'text/javascript'
    script.src = url + queryString
    script.async = true
    script.defer = true

    script = document.body.appendChild(script)
  }

  const executeCaptcha = (): Promise<string> => {
    if (!isReady) {
      throw new Error("Captcha can be executed only when it's ready.")
    }

    return window.grecaptcha.execute()
  }

  return props.children({
    isReady: isReady,
    execute: executeCaptcha
  })
}
